<template>
  <div class="vs-con-loading__container" id="LastOrderCont">
    <h4 class="card-title d-flex">{{$t('DASHBOARD.LAST_CHANGE.ORDER')}}
      <div class="ml-auto text-right">
        <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
      </div>
    </h4>
    <vs-list>
      <template v-for="(data, indextr) in lastChangedOrders" >
        <vs-list-item :key="'order_'+indextr"  :title="data.debitor.nameMin +', '+ data.order.bez + ' ('+data.order.order_nr+')'" :subtitle="DateToString(data.order.last_change,false)">
          <vs-button  @click="NavigateTo(data.order.id)"  size="small" color="primary" type="filled" icon="open_in_new"></vs-button>
        </vs-list-item>
      </template>
    </vs-list>
  </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';

export default {
  name: "LastOrder",
  props:[],
   data: function (){
     return {
       lastChangedOrders:[]
     }
  },
  mounted:function(){
      this.LoadData();
  },
  computed:{
    lastChangedOrders_data(){
      var data = [];
      if(this.$store.state.dashboarddata.lastChangedOrders.data != null)
      {
        data = this.$store.state.dashboarddata.lastChangedOrders.data;
      }
      return data;
    },
    loading(){
      var loading = true;
      if(typeof(this.$store.state.dashboarddata.lastChangedOrders.status) != 'undefined')
        loading = this.$store.state.dashboarddata.lastChangedOrders.status.loading;
      return loading;
    }
  },
  methods:{
    ...helperMethods,
    LoadData(){
      this.$store.dispatch('dashboarddata/getLastChangedOrders',{ root: true },{ root: true }); 
    },
    NavigateTo(id)
    {
      this.$router.push({ name: 'Order', params: { order_fk: id } });
    }
  },
  watch:{
    lastChangedOrders_data(value)
    {
      this.lastChangedOrders = value;
    },
    loading(value)
    {
      if(value)
      {
        this.$store.dispatch('alertqueue/showLoader', {'id':'#LastOrderCont'});
      }
      else
      {
        this.$store.dispatch('alertqueue/hideLoader', {'id':'#LastOrderCont'});
      }
    }
  }
};
</script>
